import { theme as WebComponentsTheme } from '@acorns/web-components'
import { path as getForPath } from 'ramda'

export const theme = (path: string) => (props: any) =>
  getForPath(path.split('.'), props.theme) as string | number

export const style = (cb: (theme: typeof themeObj) => any) => (props: any) => cb(props.theme)

const themeObj = {
  ...WebComponentsTheme,
}

export type ThemeProps = {
  theme: typeof themeObj
}

export default themeObj
